import { TooltipContent, TooltipProvider, TooltipRoot, TooltipTrigger, isMac } from "./utils-BLJzxVW-.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Tooltip/toggleAll.ts
/** True for the click that should fold or unfold every group: Cmd on a Mac, Ctrl elsewhere. */
const isToggleAllClick = (event) => isMac ? event.metaKey : event.ctrlKey;
//#endregion
//#region src/components/Tooltip/ToggleAllTooltip.tsx
/**
* A fold chevron's tooltip: what a click does, and what the modifier click does to every group.
*
* - Its own provider, so a host without one still renders it.
* - `data-slot` lets an app with its own popper z-index lift it over a popup.
*/
const ToggleAllTooltip = ({ expanded, children }) => {
	const verb = expanded ? "collapse" : "expand";
	return /* @__PURE__ */ jsx(TooltipProvider, { children: /* @__PURE__ */ jsxs(TooltipRoot, { children: [/* @__PURE__ */ jsx(TooltipTrigger, {
		asChild: true,
		children
	}), /* @__PURE__ */ jsx(TooltipContent, {
		placement: "top",
		"data-slot": "toggle-all-tooltip",
		children: /* @__PURE__ */ jsxs("span", {
			className: "tw:flex tw:flex-col",
			children: [/* @__PURE__ */ jsxs("span", { children: ["Click to ", verb] }), /* @__PURE__ */ jsxs("span", {
				className: "tw:opacity-70",
				children: [
					isMac ? "⌘" : "Ctrl",
					"+click to ",
					verb,
					" all"
				]
			})]
		})
	})] }) });
};
//#endregion
export { ToggleAllTooltip, isToggleAllClick };

//# sourceMappingURL=ToggleAllTooltip-Bcrtvxm4.js.map